import React, { useEffect, useState } from "react";
import { checkTiersDuplicate } from "../../api";
import { AlertTriangle } from "lucide-react";
import { log } from "../../lib/log";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/* Warns while typing when a Dolibarr third party / CRM prospect already uses this email (or exact name). */
const DuplicateHint = ({ email, name = "", onResult }) => {
  const [res, setRes] = useState(null);
  useEffect(() => {
    const okEmail = EMAIL_RE.test(email || "");
    if (!okEmail && (name || "").trim().length < 3) { setRes(null); onResult?.(null); return undefined; }
    const t = setTimeout(() => {
      checkTiersDuplicate(okEmail ? email : "", name).then((r) => { setRes(r.data); onResult?.(r.data); }).catch(log.error);
    }, 500);
    return () => clearTimeout(t);
  }, [email, name]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!res?.exists) return null;
  return (
    <div className="sm:col-span-full bg-amber-50 border border-amber-200 rounded-md px-3 py-2 text-sm text-amber-900 flex gap-2" data-testid="duplicate-hint">
      <AlertTriangle size={16} className="shrink-0 mt-0.5" />
      <div>
        <p className="font-semibold">Doublon probable</p>
        <ul className="text-xs mt-0.5 space-y-0.5">
          {res.matches.map((m) => <li key={m.id} data-testid={`duplicate-tiers-${m.id}`}>Tiers Dolibarr <b>{m.name}</b> #{m.id}{m.email && ` · ${m.email}`}{m.town && ` · ${m.town}`} ({m.reason})</li>)}
          {res.prospects.map((p) => <li key={p.id} data-testid={`duplicate-prospect-${p.id}`}>Prospect CRM <b>{p.societe}</b>{p.dolibarr_socid && ` (tiers #${p.dolibarr_socid})`}</li>)}
        </ul>
        <p className="text-xs mt-1">Vous pouvez tout de même créer la fiche : une confirmation vous sera demandée.</p>
      </div>
    </div>
  );
};

export default DuplicateHint;
